export default process.env.NODE_ENV === "development"
  ? "http://localhost:5051"
  : process.env.NODE_ENV === "production" &&
  "https://cv.vectorindia.org/cvapi";
